import Axios from './axios_wrapper'

export function adminSearch(searchText) {
  return Axios({
    url: `/admin/search?filter=${searchText}`,
    method: 'GET'
  })
}

export function search(searchText) {
  return Axios({
    url: `/search?filter=${searchText}`,
    method: 'GET'
  })
}

export function distributorSearch(searchText) {
  return Axios({
    url: `/distributor/search?filter=${searchText}`,
    method: 'GET'
  })
}

export function hospitalAdminSearch(searchText) {
  return Axios({
    url: `/hospital_admin/search?filter=${searchText}`,
    method: 'GET'
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/search.js
// module id = null
// module chunks = 